module.exports = __webpack_public_path__ + "static/media/vehicle14.6ae1635b.svg";